import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Versions.svg?component
var Versions_exports = /* @__PURE__ */ __exportAll({
	default: () => Versions_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m5.246 12.069-2.74 1.569a1 1 0 0 0 .001 1.74l8.5 4.87a2 2 0 0 0 2 0l8.5-4.87a.999.999 0 0 0 0-1.74l-2.702-1.548m-5.798 3.158a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74l8.5-4.87a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74z"
	}, null, -1)])]);
}
var Versions_default = { render: render$1 };
//#endregion
export { Versions_exports, Versions_default as default, render$1 as render };

//# sourceMappingURL=Versions.svg.virtual.js.map